import React from "react";
import { APP_VERSION } from "../version";

function Footer(props) {
    return (
        <footer className="main-footer">
            <strong>
                copyright © 2025{" "}
                <a href="https://www.starek.in">www.starek.in</a>
            </strong>

            <div className="float-right d-none d-sm-inline-block">
                <a className="text-sm" href="https://www.starek.in">
                    Terms and Conditions
                </a>
                {" | "}
                <a className="text-sm" href="https://www.starek.in">
                    Privacy Policy
                </a>
                {" | "}
                <b>Version</b> {APP_VERSION}
            </div>
        </footer>
    );
}

export default Footer;
